/** Rahmen der Karten auf der Uebersicht: Titel, Zahl, Link "Oeffnen". */
import { Link } from 'react-router-dom';
import type { CalendarDays } from 'lucide-react';

import { cn } from '@/lib/utils/cn';

export function Card({
  title, icon: Icon, to, badge, children,
}: {
  title: string;
  icon: typeof CalendarDays;
  to: string;
  badge?: string;
  children: React.ReactNode;
}) {
  return (
    <section aria-label={title} className="rounded-lg border border-line bg-surface px-5 py-[18px]">
      <header className="mb-2 flex items-center gap-2">
        <Icon className="size-4 shrink-0 text-ink-faint" />
        <h2 className="flex-1 text-[15px] font-bold">{title}</h2>
        {badge && (
          <span className="rounded-full bg-surface-raised px-2 py-px text-[11px] tabular-nums text-ink-muted">
            <span className="sr-only">Anzahl: </span>{badge}
          </span>
        )}
        <Link
          to={to}
          className={cn(
            'text-[12px] text-ink-faint underline-offset-2',
            'transition-colors hover:text-ink hover:underline',
          )}
        >
          Öffnen
        </Link>
      </header>
      {children}
    </section>
  );
}

export function Empty({ children }: { children: React.ReactNode }) {
  return <p className="py-1 text-sm text-ink-faint">{children}</p>;
}
